// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.orderingpointssearch.orderingpoints', {
        url: "/{articleId}",
        views: {
            "articleView@stock": {
                templateUrl: 'main/stocklogistics/orderingpoints/orderingpoints.tpl.html',
                controller: 'OrderingPointsController as vm'
            }
        },

        resolve: {
            article: articleResolver,
            locations: locationsResolver,
            autoMonthMultipliers: multiplierResolver,
        }
    });
}

// @ngInject
function articleResolver($stateParams, StockLogisticsApiService) {
    return StockLogisticsApiService.getProduct($stateParams.articleId);
}

// @ngInject
function locationsResolver(StockLogisticsApiService) {
    return StockLogisticsApiService.getLocations();
}


// @ngInject
function multiplierResolver($stateParams, ProductsApiService) {
    return ProductsApiService.getMultipliers($stateParams.articleId);
}

// @ngInject
function OrderingPointsController($state, $rootScope, $translate, ToasterService, article, locations,ProductsApiService, StockLogisticsApiService, loadSpinnerService, ArticleLabelsPrintDialogService, AutoMonthMultiplierDialogService, autoMonthMultipliers) {
    var vm = this;

    var locationBasedRowData = [];
    var locationBasedRowCollection = new wijmo.collections.CollectionView(locationBasedRowData);
    var orderPointsGrid = {};
    var currentEditProperty = 'orderingPointMax';
    vm.selectedArticle = article;
    vm.autoMonthMultipliers = initializeAutoMonthMultipliers(autoMonthMultipliers);
    vm.selectedMultiplier = filterSelectedMultiplier(autoMonthMultipliers);
    vm.stockLogistics = [];
    vm.locations = formatLocationNames(locations);
    vm.selectableFromLocations = [];
    vm.selectedLocation = {};
    vm.selectedFromLocation = {};

    vm.captureVariantsGrid = captureVariantsGrid;
    vm.transferMaxGridDataToStockLogistics = transferMaxGridDataToStockLogistics;
    vm.selectedLocationChanged = selectedLocationChanged;
    vm.saveStockLogistics = saveStockLogistics;

    vm.switchToOrderingPointMax = switchToOrderingPointMax;
    vm.switchToOrderingPointMin = switchToOrderingPointMin;
    vm.switchToPackSize = switchToPackSize;
    vm.generateAutoOrdersForAllStockLogistics = generateAutoOrdersForAllStockLogistics;
    
    vm.openLabelsModal = openLabelsModal;
    vm.openMultiplierModal = openMultiplierModal;

    vm.tabSelection = {
        maxPoint: true,
        minPoint: false,
        packSize: false
    };

    vm.isPriority = false;

    vm.weekdaychoices = {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false
    };

    vm.printDebug = printDebug;
    vm.productStateGo = productStateGo;

    activate();

    function formatLocationNames(locations) {
        return locations.map(function(location) {
            var formattedLocation = angular.copy(location);
            formattedLocation.locationName = formattedLocation.shouldGenerateAutoOrders ? formattedLocation.locationName + ' (' + $translate.instant('common.active') + ')' : formattedLocation.locationName + ' (' + $translate.instant('common.inActive') + ')';
            return formattedLocation;
        });
    }

    $rootScope.$on('multiplierModalClosed', function(event, selectedItem) {
        ProductsApiService.getMultipliers(vm.selectedArticle.id).then(function(response) {
            vm.autoMonthMultipliers = angular.copy(response);
            vm.selectedMultiplier = filterSelectedMultiplier(response);
        });
    });

    function activate() {
        StockLogisticsApiService.getByArticle(vm.selectedArticle.id).then(function (response) {
            vm.stockLogistics = response.data;
            updateOrderPointsGridData();
            populateSelectableFromLocations();
        }, function(error) {
            console.log(error);
        });

        populateSelectableFromLocations();
    }

    function filterSelectedMultiplier(autoMonthMultipliers) {
        if (autoMonthMultipliers && autoMonthMultipliers.length > 0) {
            return autoMonthMultipliers.find(x => x.isArticlesMultiplier);
        } else {
            return null;
        }
    }

    function initializeAutoMonthMultipliers(sourceArray) {
        const copiedArray = angular.copy(sourceArray);
        return copiedArray || [];
    }
    
    

    function openLabelsModal() {
        ArticleLabelsPrintDialogService.showDialog(vm.selectedArticle.id);
    }

    function openMultiplierModal() {
        AutoMonthMultiplierDialogService.showDialog(vm.selectedArticle.id);
    }
    
    function captureVariantsGrid(sender) {
        orderPointsGrid = sender;
        orderPointsGrid.initialize({
            autoGenerateColumns: false,
            selectionMode: wijmo.grid.SelectionMode.Cell,
            allowDragging: wijmo.grid.AllowDragging.None,
            allowResizing: wijmo.grid.AllowResizing.Columns,
            headersVisibility: wijmo.grid.HeadersVisibility.Column,
            isReadOnly: false,
            itemsSource: locationBasedRowCollection
        });
        updateOrderPointsGridData();
    }

    function updateOrderPointsGridData() {
        if (orderPointsGrid.columns === undefined) {
            return;
        }

        var variantDetail1s = [];
        var variantDetail2s = [];
        var stockLogisticsForCurrentLocation = [];

        _.each(vm.selectedArticle.articleVariants, function(articleVariant) {
            variantDetail1s.push(articleVariant.variantDetail1);
            variantDetail2s.push(articleVariant.variantDetail2);
        });

        variantDetail1s =  _.uniqBy(variantDetail1s, function(detail) {
            return detail.id; // Compare by ID
        });
        variantDetail2s = _.uniqBy(variantDetail2s, function(detail) {
            return detail.id; // Compare by ID
        });

        variantDetail1s = _.sortBy(variantDetail1s, function(detail) { return detail.variantDetailName; });
        variantDetail2s = _.sortBy(variantDetail2s, function(detail) { return detail.sortOrder; });

        orderPointsGrid.columns.clear();
        orderPointsGrid.columns.defaultSize = 50;
        orderPointsGrid.frozenColumns = 1;

        // Add first row header column
        var rowHeader = new wijmo.grid.Column();
        rowHeader.binding = "variantDetails1Name";
        rowHeader.header = " ";
        rowHeader.allowSorting = false;
        rowHeader.width = "*";
        rowHeader.minWidth = 120;
        rowHeader.isReadOnly = true;
        orderPointsGrid.columns.push(rowHeader);

        _.each(variantDetail2s, function(varDetail2) {
            var column = new wijmo.grid.Column();
            column.binding = varDetail2.variantDetailName;
            column.header = varDetail2.variantDetailName;
            column.align = "right";
            column.width = "*";
            column.minWidth = 60;
            orderPointsGrid.columns.push(column);
        });

        stockLogisticsForCurrentLocation = _.filter(vm.stockLogistics, function(stockLogistic) {
            return vm.selectedLocation.id === stockLogistic.location.id;
        });

        if (stockLogisticsForCurrentLocation.length > 0) {
            if (stockLogisticsForCurrentLocation[0].isPriority === undefined) {
                vm.isPriority = false;
            } else {
                vm.isPriority = stockLogisticsForCurrentLocation[0].isPriority;
            }
        }

        orderPointsGrid.autoSizeColumn(0);

        setCurrentWeekdayChoices(stockLogisticsForCurrentLocation);

        loadVariantsGridData(stockLogisticsForCurrentLocation);
    }

    function loadVariantsGridData(currentLocationStockLogistics) {
        var variantRows = _.groupBy(vm.selectedArticle.articleVariants, function(variant) {
            return variant.variantDetail1.id;
        });

        locationBasedRowData = [];
        locationBasedRowCollection = new wijmo.collections.CollectionView(locationBasedRowData);

        orderPointsGrid.itemsSource = locationBasedRowCollection;
        orderPointsGrid.collectionView.refresh();

        _.each(variantRows, function(variantRowValues) {
            var r = {};
            _.each(variantRowValues, function(variantRowValue) {
                var relatedStockLogistic = _.find(currentLocationStockLogistics, function(stock) { return stock.articleVariant.id === variantRowValue.id; });
                r.variantDetails1Name = variantRowValue.variantDetail1.variantDetailName;
                if (relatedStockLogistic !== undefined) {
                    r[variantRowValue.variantDetail2.variantDetailName] = relatedStockLogistic[currentEditProperty];
                } else {
                    r[variantRowValue.variantDetail2.variantDetailName] = 0;
                }
            });
            locationBasedRowData.push(r);
        });
        locationBasedRowCollection.refresh();
    }

    function transferMaxGridDataToStockLogistics() {
        var stockLogisticsForCurrentLocation = _.filter(vm.stockLogistics, function(stockLogistic) {
            return vm.selectedLocation.id === stockLogistic.location.id;
        });

        _.forEach(locationBasedRowData, function(row) {
            var keys = Object.keys(row);
            _.forEach(keys, function(variant2Name) {
                if (variant2Name !== 'variantDetails1Name') {
                    var relatedStockLogistic = _.find(stockLogisticsForCurrentLocation, function(stockLogistic) {
                        return stockLogistic.articleVariant.variantDetail1.variantDetailName === row['variantDetails1Name'] &&
                            stockLogistic.articleVariant.variantDetail2.variantDetailName === variant2Name &&
                            stockLogistic.location.id === vm.selectedLocation.id;
                        }
                    );

                    if (relatedStockLogistic !== undefined) { // Update the fetched stock logistic.
                        relatedStockLogistic[currentEditProperty] = row[variant2Name];
                        relatedStockLogistic.isPriority = vm.isPriority;
                        updateStockLogisiticsWeekdays(relatedStockLogistic, vm.weekdaychoices);
                    } else { // Create a new stock logistic.
                        var newStockLogistics = createNewStockLogistics(row['variantDetails1Name'], variant2Name);
                        newStockLogistics[currentEditProperty] = row[variant2Name];
                        updateStockLogisiticsWeekdays(newStockLogistics, vm.weekdaychoices);
                        newStockLogistics.isPriority = vm.isPriority;
                        vm.stockLogistics.push(newStockLogistics);
                    }

                }
            });
        });
    }

    function getGenerallWeekdayChoice(relatedStockLogistics){
        var returnStockLogistic = {
            monday : false,
            tuesday : false,
            wednesday : false,
            thursday : false,
            friday : false,
            saturday : false,
            sunday : false
        };

        _.forEach(relatedStockLogistics, function(stockLogistic){
            if(stockLogistic.monday){
                returnStockLogistic.monday = stockLogistic.monday;
            }
            if(stockLogistic.tuesday){
                returnStockLogistic.tuesday = stockLogistic.tuesday;
            }
            if(stockLogistic.wednesday){
                returnStockLogistic.wednesday = stockLogistic.wednesday;
            }
            if(stockLogistic.thursday){
                returnStockLogistic.thursday = stockLogistic.thursday;
            }
            if(stockLogistic.friday){
                returnStockLogistic.friday = stockLogistic.friday;
            }
            if(stockLogistic.saturday){
                returnStockLogistic.saturday = stockLogistic.saturday;
            }
            if(stockLogistic.sunday){
                returnStockLogistic.sunday = stockLogistic.sunday;
            }
        });


        return returnStockLogistic;
    }

    function setCurrentWeekdayChoices(relatedStockLogistics) {
        var stockLogistic = getGenerallWeekdayChoice(relatedStockLogistics)

        if (stockLogistic) {
            vm.weekdaychoices.monday = stockLogistic.monday;
            vm.weekdaychoices.tuesday = stockLogistic.tuesday;
            vm.weekdaychoices.wednesday = stockLogistic.wednesday;
            vm.weekdaychoices.thursday = stockLogistic.thursday;
            vm.weekdaychoices.friday = stockLogistic.friday;
            vm.weekdaychoices.saturday = stockLogistic.saturday;
            vm.weekdaychoices.sunday = stockLogistic.sunday;
        } else {
            vm.weekdaychoices.monday = false;
            vm.weekdaychoices.tuesday = false;
            vm.weekdaychoices.wednesday = false;
            vm.weekdaychoices.thursday = false;
            vm.weekdaychoices.friday = false;
            vm.weekdaychoices.saturday = false;
            vm.weekdaychoices.sunday = false;
        }

    }

    function updateStockLogisiticsWeekdays(stockLogistic, weekdayChoices) {
        stockLogistic.monday = weekdayChoices.monday;
        stockLogistic.tuesday = weekdayChoices.tuesday;
        stockLogistic.wednesday = weekdayChoices.wednesday;
        stockLogistic.thursday = weekdayChoices.thursday;
        stockLogistic.friday = weekdayChoices.friday;
        stockLogistic.saturday = weekdayChoices.saturday;
        stockLogistic.sunday = weekdayChoices.sunday;
    }

    function createNewStockLogistics(variantDetail1Name, variantDetail2Name) {
        var newStockLogistic = {
            id: 0,
            location: {
                id: vm.selectedLocation.id,
                locationName: vm.selectedLocation.locationName,
                locationNumber: vm.selectedLocation.locationNumber
            },
            orderingPointMax: 0,
            orderingPointMin: 0,
            packSize: 0,
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
            isPriority: false
        };

        newStockLogistic['articleVariant'] = _.find(vm.selectedArticle.articleVariants, function(articleVariant) {
           return articleVariant.variantDetail1.variantDetailName === variantDetail1Name &&
               articleVariant.variantDetail2.variantDetailName === variantDetail2Name;
        });

        return newStockLogistic;
    }

    function selectedLocationChanged(sender) {
        if (!sender.selectedItem) {
            return;
        }

        if (orderPointsGrid.columns !== undefined) {
            transferMaxGridDataToStockLogistics();
        }

        copyFromLocationToStockLogistic();

        vm.selectedLocation = sender.selectedItem;

        populateSelectableFromLocations();

        updateOrderPointsGridData();
    }

    function switchToOrderingPointMax() {
        transferMaxGridDataToStockLogistics();
        currentEditProperty = 'orderingPointMax';
        updateOrderPointsGridData();

        setAllTabSelectionsToFalse();
        vm.tabSelection.maxPoint = true;
    }

    function switchToOrderingPointMin() {
        transferMaxGridDataToStockLogistics();
        currentEditProperty = 'orderingPointMin';
        updateOrderPointsGridData();

        setAllTabSelectionsToFalse();
        vm.tabSelection.minPoint = true;
    }

    function switchToPackSize() {
        transferMaxGridDataToStockLogistics();
        currentEditProperty = 'packSize';
        updateOrderPointsGridData();

        setAllTabSelectionsToFalse();
        vm.tabSelection.packSize = true;
    }

    function setAllTabSelectionsToFalse() {
        var keys = Object.keys(vm.tabSelection);
        _.forEach(keys, function(key) {
            vm.tabSelection[key] = false;
        });
    }

    function generateAutoOrdersForAllStockLogistics() {
        loadSpinnerService.start('mainSpinner');
        StockLogisticsApiService.generateAutoOrders().then(function(response) {
            $state.go('order.ordersearch');
        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function saveStockLogistics() {
        transferMaxGridDataToStockLogistics();
        copyFromLocationToStockLogistic();
        loadSpinnerService.start('mainSpinner');
        StockLogisticsApiService.saveStockLogistics({stockLogisticsDtos: vm.stockLogistics, autoMonthMultiplier: vm.selectedMultiplier}).then(function(response) {
            vm.stockLogistics = response.data;
            ToasterService.showSuccess($translate.instant('common.wasSaved'));
        }, function(error) {
            showWarningToaster("Error");
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function populateSelectableFromLocations() {
        vm.selectableFromLocations = [];
        vm.selectableFromLocations.length = 0;
        var supplierLabel = $translate.instant('order.company');
        vm.selectableFromLocations.push({locationName: supplierLabel});
        _.forEach(vm.locations, function(location) {
            if (vm.selectedLocation.id !== location.id) {
                vm.selectableFromLocations.push(location);
            }
        });
        var currentStockLogistic = _.find(vm.stockLogistics, function(stockLogistic) {
            return stockLogistic.location.id === vm.selectedLocation.id;
        });

        if (currentStockLogistic !== undefined && currentStockLogistic.fromLocation !== undefined) {
            vm.selectedFromLocation = _.find(vm.selectableFromLocations, function(fromLocation) {
                return fromLocation.id === currentStockLogistic.fromLocation.id;
            });
        } else {
            vm.selectedFromLocation = vm.selectableFromLocations[0];
        }
    }

    function copyFromLocationToStockLogistic() {
        var currentStockLogistics = _.filter(vm.stockLogistics, function(stockLogistic) {
            return stockLogistic.location.id === vm.selectedLocation.id;
        });


        _.forEach(currentStockLogistics, function(currentStockLogistic) {
            if (!vm.selectedFromLocation.id) {
                currentStockLogistic.fromLocation = {};
            } else {
                currentStockLogistic.fromLocation = vm.selectedFromLocation;
            }
        });
    }

    function showWarningToaster(message) {
        var title = $translate.instant('common.warning');
        ToasterService.showWarning(message, title);
    }

    function printDebug() {
        console.log("vm.stockLogistics");
        console.log(vm.stockLogistics);
        console.log("vm.selectedLocation");
        console.log(vm.selectedLocation);
    }

    function productStateGo(stringState) {
        $state.go(stringState, 
            {
                articleId: vm.selectedArticle.id,
                filter: $state.params.filter,
                currentPage:  $state.params.currentPage,
                pageSize:  $state.params.pageSize,
                inactive:  $state.params.inactive,
                match:  $state.params.match
            }
        );
    }
}


angular
    .module('stocklogistics.orderingpoints', [])
    .config(stateConfig)
    .controller('OrderingPointsController', OrderingPointsController);
